// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3B7ge","validationTips":"StatementDescriptor_validationTips__3oSk6"};